import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { TABS } from './constants';
import FilteredStatsTab from './FilteredStatsTab';
import MatchHistoryTab from './MatchHistoryTab';
import LifetimeTab from './LifetimeTab';
import { usePlayerProfileData } from './usePlayerProfileData';

const PlayerProfilePanel = ({
  playerId,
  playerName,
  playerStats = [],
  teamId,
  selectedSeason,
  seasonDocId,
  seasonDisplayLabel,
  startDate,
  endDate,
  matchType,
  region,
  playerImage,
  onPreviousPlayer,
  onNextPlayer,
}) => {
  const {
    activeTab,
    setActiveTab,
    filteredModeCards,
    filteredSummary,
    filteredGameHighs,
    historyLoading,
    historyError,
    historyModeFilter,
    setHistoryModeFilter,
    historyMapFilter,
    setHistoryMapFilter,
    historyRangeFilter,
    setHistoryRangeFilter,
    availableHistoryMaps,
    filteredMatchHistory,
    historySummary,
    recentTrend,
    winLossSplit,
    mapPerformance,
    operatorAnalytics,
  } = usePlayerProfileData({
    playerId,
    playerName,
    playerStats,
    teamId,
    selectedSeason,
    seasonDocId,
    startDate,
    endDate,
    matchType,
    region,
  });

  const regionLabel = region || '';

  return (
    <section className="ppm-panel">
      <header className="ppm-header ppm-panel-header">
        <div className="ppm-header-main">
          <div className="ppm-player-nav" aria-label={`${playerName || 'Player'} navigation`}>
            <button
              type="button"
              onClick={onPreviousPlayer}
              className="ppm-nav-btn"
              aria-label={`View previous player before ${playerName || 'current player'}`}
              disabled={!onPreviousPlayer}
            >
              <FiChevronLeft />
            </button>
            <button
              type="button"
              onClick={onNextPlayer}
              className="ppm-nav-btn"
              aria-label={`View next player after ${playerName || 'current player'}`}
              disabled={!onNextPlayer}
            >
              <FiChevronRight />
            </button>
          </div>
          {playerImage
            ? <img src={playerImage} alt={playerName} className="ppm-avatar" />
            : <div className="ppm-avatar-fallback">{String(playerName || '?').charAt(0).toUpperCase()}</div>}
          <div style={{ minWidth: 0 }}>
            <h2 className="ppm-title">{playerName}</h2>
            {regionLabel ? <p className="ppm-subtitle">Region: {regionLabel}</p> : null}
          </div>
        </div>
      </header>

      <div className="ppm-tabs-wrap">
        <nav className="ppm-tabs" aria-label={`${playerName || 'Player'} profile tabs`}>
          <button type="button" onClick={() => setActiveTab(TABS.FILTERED)} className={`ppm-tab ${activeTab === TABS.FILTERED ? 'active' : ''}`}>Filtered Stats</button>
          <button type="button" onClick={() => setActiveTab(TABS.HISTORY)} className={`ppm-tab ${activeTab === TABS.HISTORY ? 'active' : ''}`}>Match History</button>
          <button type="button" onClick={() => setActiveTab(TABS.LIFETIME_COMING_SOON)} className={`ppm-tab ${activeTab === TABS.LIFETIME_COMING_SOON ? 'active' : ''}`}>Lifetime Stats</button>
        </nav>
      </div>

      <div className="player-modal-scroll">
        {activeTab === TABS.FILTERED && (
          <FilteredStatsTab
            seasonDocId={seasonDocId}
            selectedSeason={selectedSeason}
            seasonDisplayLabel={seasonDisplayLabel}
            filteredSummary={filteredSummary}
            filteredModeCards={filteredModeCards}
            filteredGameHighs={filteredGameHighs}
            winLossSplit={winLossSplit}
            mapPerformance={mapPerformance}
            operatorAnalytics={operatorAnalytics}
          />
        )}
        {activeTab === TABS.HISTORY && (
          <MatchHistoryTab
            historyModeFilter={historyModeFilter}
            setHistoryModeFilter={setHistoryModeFilter}
            historyMapFilter={historyMapFilter}
            setHistoryMapFilter={setHistoryMapFilter}
            historyRangeFilter={historyRangeFilter}
            setHistoryRangeFilter={setHistoryRangeFilter}
            availableHistoryMaps={availableHistoryMaps}
            filteredMatchHistory={filteredMatchHistory}
            historySummary={historySummary}
            recentTrend={recentTrend}
            historyLoading={historyLoading}
            historyError={historyError}
          />
        )}
        {activeTab === TABS.LIFETIME_COMING_SOON && <LifetimeTab />}
      </div>
    </section>
  );
};

export default PlayerProfilePanel;
